var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownloadWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 20,
    viewBox: "0 0 16 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.8715 0.820162C10.4964 0.445089 9.98772 0.234375 9.45729 0.234375H2C0.895431 0.234375 0 1.1298 0 2.23437V17.6629C0 18.7675 0.895431 19.6629 2 19.6629H14C15.1046 19.6629 16 18.7675 16 17.6629V6.77709C16 6.24666 15.7893 5.73795 15.4142 5.36288L10.8715 0.820162Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3339 10.7344L10.7464 10.0882L8.41724 12.6457V7.06775H7.5839V12.6457L5.2589 10.0836L4.66724 10.7344L8.00057 14.4011L11.3339 10.7344Z",
    fill: "#DD484C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadWhite);
export default __webpack_public_path__ + "static/media/download-white.1d28a68360275332c5142bf3de09efb7.svg";
export { ForwardRef as ReactComponent };